import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule} from '@angular/forms';
import { RouterLink, Router} from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';
import { Client } from '../../../../api/api-reference';

@Component({
  selector: 'app-on-demand-alarm-setup',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    RouterLink,
    AngularSvgIconModule,
    TranslateModule,
  ],  templateUrl: './on-demand-alarm-setup.component.html',
  styleUrl: './on-demand-alarm-setup.component.scss'
})
export class OnDemandAlarmSetupComponent {
  meterNo: string = "";
  constructor(
    private client: Client,
    private toastr: ToastrService,
    private router:Router
  ) {}

  onSubmit() {
    this.client.onDemandReadAlarms(this.meterNo).subscribe({
      next: (response) => {
        this.toastr.success(response.message);
        this.router.navigate(['events/on-demand'])
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
